export enum Modes {
  Add = 'Add',
  Edit = 'Edit',
  View = 'View',
}

export enum SiteStatus {
  Inactive = 'inactive',
  Active = 'active',
}
